import { render, staticRenderFns } from "./PageApps.vue?vue&type=template&id=41c37b00"
import script from "./PageApps.vue?vue&type=script&lang=js"
export * from "./PageApps.vue?vue&type=script&lang=js"
import style0 from "./PageApps.vue?vue&type=style&index=0&id=41c37b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports